import { useEffect } from 'react';
import { useActions } from '@/utils/redux';

export default function InitData() {

  const { getXiaoRuiAppIds } = useActions(({ book }) => book);

  useEffect(() => {
    getXiaoRuiAppIds();
  }, []);
  return null;
}
